// extracted by mini-css-extract-plugin
export default {"container":"BillingCard_container__OiDQp","text":"BillingCard_text__lhV1X"};